"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ChipItem = require("./ChipItem.style");
var _IconButton = require("../IconButton");
var _excluded = ["label", "onClick", "icon", "themeColor"];
var ChipItem = function ChipItem(_ref) {
  var _themeColor$default;
  var label = _ref.label,
    onClick = _ref.onClick,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'close' : _ref$icon,
    themeColor = _ref.themeColor,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipContainer, (0, _extends2["default"])({
    color: themeColor
  }, params), label, onClick && /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    dense: true,
    style: {
      marginLeft: '4px'
    },
    colored: true,
    color: "white",
    containerColor: (_themeColor$default = themeColor === null || themeColor === void 0 ? void 0 : themeColor["default"]) !== null && _themeColor$default !== void 0 ? _themeColor$default : '#212121',
    format: "round",
    size: 8,
    icon: icon,
    onClick: onClick
  }));
};
var _default = exports["default"] = ChipItem;